module.exports = __webpack_public_path__ + "static/img/title.576f955e.png";